(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTitleBarSaveButton', drvTitleBarSaveButton);

    drvTitleBarSaveButton.$inject = [];

    /**
     * @ngdoc directive
     * @name drvTitleBarSaveButton
     * 
     * @description
     * Creates a title bar button specifically used for saving an item.
     * To be used with drvTitleBar.
     *
     * # Scope Properties
     * {string} itemName - Text to be shown for the caption after 'Save' E.g. 'Save <text>'. Optional.
     * {function} onClick - Function to be invoked when the button is clicked. Optional.
     * {bool} disabled - Disables the button. Optional.
     */
    function drvTitleBarSaveButton() {
        var directive = {
            restrict: 'E',
            scope: {
                itemName: '<?',
                onClick: '&?',
                disabled: '<?'
            },
            template:
                '<drv-title-bar-button class="save-button" icon="\'content-save\'" text="\'Save\'" caption="\'Save\' + (itemName ? \' \' + itemName : \'\')" on-click="onClick()" disabled="disabled"></drv-title-bar-button>'
        };
        return directive;
    }
})();